const JBP_PLANNING_SMB = 'jbp-planning-smb'

export const PLANNING_SMB_TRANSLATION_KEYS = {
  cell: {
    // The same option label the Display Settings checkbox uses, so the panel is named
    // exactly like the setting that reveals it
    label: 'jbp-planning-show-smb-vs-eu-split',
    planned: `${JBP_PLANNING_SMB}-status-planned`,
    notPlanned: `${JBP_PLANNING_SMB}-status-not-planned`,
    plan: `${JBP_PLANNING_SMB}-action-plan`,
    updatePlan: `${JBP_PLANNING_SMB}-action-update-plan`,
    guidedSetup: `${JBP_PLANNING_SMB}-action-guided-setup`,
  },
  /** Shown instead of opening the editor while the Financial Plan has unsaved changes */
  blocked: {
    title: `${JBP_PLANNING_SMB}-blocked-title`,
    message: `${JBP_PLANNING_SMB}-save-financial-plan-first`,
    confirm: `${JBP_PLANNING_SMB}-blocked-confirm`,
  },
  modal: {
    title: `${JBP_PLANNING_SMB}-modal-title`,
    subTitle: `${JBP_PLANNING_SMB}-modal-sub-title`,
    quarterlyPlanning: 'jbp-planning-quarter-switcher',
    showFinancialData: `${JBP_PLANNING_SMB}-modal-show-financial-data`,
    baselineSelectLabel: `${JBP_PLANNING_SMB}-modal-baseline-select-label`,
    hierarchyRule: `${JBP_PLANNING_SMB}-modal-hierarchy-rule`,
    columnHierarchy: `${JBP_PLANNING_SMB}-modal-column-hierarchy`,
    offeringTotal: `${JBP_PLANNING_SMB}-modal-offering-total`,
    // The same wording Planning shows for a category switched off as Not applicable
    notApplicable: 'jbp-not-applicable-status-not-applicable',
    disabled: `${JBP_PLANNING_SMB}-modal-disabled`,
    columnFySplit: `${JBP_PLANNING_SMB}-modal-column-fy-split`,
    columnFyWeighted: `${JBP_PLANNING_SMB}-modal-column-fy-weighted`,
    plan: `${JBP_PLANNING_SMB}-modal-plan`,
    baselineTag: `${JBP_PLANNING_SMB}-modal-baseline-tag`,
    noBaseline: `${JBP_PLANNING_SMB}-modal-no-baseline`,
    notEntered: `${JBP_PLANNING_SMB}-modal-not-entered`,
    expand: `${JBP_PLANNING_SMB}-modal-expand`,
    collapse: `${JBP_PLANNING_SMB}-modal-collapse`,
    footNotePlanned: `${JBP_PLANNING_SMB}-modal-foot-note-planned`,
    footNoteNotPlanned: `${JBP_PLANNING_SMB}-modal-foot-note-not-planned`,
    cancel: `${JBP_PLANNING_SMB}-modal-cancel`,
    save: `${JBP_PLANNING_SMB}-modal-save`,
    saving: `${JBP_PLANNING_SMB}-modal-saving`,
    tryGuidedSetup: `${JBP_PLANNING_SMB}-modal-try-guided-setup`,
  },
  guided: {
    crumb: `${JBP_PLANNING_SMB}-guided-crumb`,
    title: `${JBP_PLANNING_SMB}-guided-title`,
    congratulationsTitle: `${JBP_PLANNING_SMB}-guided-congratulations-title`,
    congratulationsBody: `${JBP_PLANNING_SMB}-guided-congratulations-body`,
    notNow: `${JBP_PLANNING_SMB}-guided-not-now`,
    proceed: `${JBP_PLANNING_SMB}-guided-proceed`,
    reviewTitle: `${JBP_PLANNING_SMB}-guided-review-title`,
    reviewNote: `${JBP_PLANNING_SMB}-guided-review-note`,
    smbBaseline: `${JBP_PLANNING_SMB}-guided-smb-baseline`,
    euBaseline: `${JBP_PLANNING_SMB}-guided-eu-baseline`,
    noOfferingBaseline: `${JBP_PLANNING_SMB}-guided-no-offering-baseline`,
    smbFocused: `${JBP_PLANNING_SMB}-guided-smb-focused`,
    euFocused: `${JBP_PLANNING_SMB}-guided-eu-focused`,
    notFocused: `${JBP_PLANNING_SMB}-guided-not-focused`,
    showCategoryBreakdown: `${JBP_PLANNING_SMB}-guided-show-category-breakdown`,
    hideCategoryBreakdown: `${JBP_PLANNING_SMB}-guided-hide-category-breakdown`,
    noCategoryBaseline: `${JBP_PLANNING_SMB}-guided-no-category-baseline`,
    categoryShift: `${JBP_PLANNING_SMB}-guided-category-shift`,
    yoyLabel: `${JBP_PLANNING_SMB}-guided-yoy-label`,
    yoySuffix: `${JBP_PLANNING_SMB}-guided-yoy-suffix`,
    clamped: `${JBP_PLANNING_SMB}-guided-clamped`,
    smbPlanned: `${JBP_PLANNING_SMB}-guided-smb-planned`,
    euPlanned: `${JBP_PLANNING_SMB}-guided-eu-planned`,
    switchClassic: `${JBP_PLANNING_SMB}-guided-switch-classic`,
    back: `${JBP_PLANNING_SMB}-guided-back`,
    applyPlan: `${JBP_PLANNING_SMB}-guided-apply-plan`,
    overwriteBody: `${JBP_PLANNING_SMB}-guided-overwrite-body`,
  },
  confirm: {
    title: `${JBP_PLANNING_SMB}-confirm-title`,
    body: `${JBP_PLANNING_SMB}-confirm-body`,
    cancel: `${JBP_PLANNING_SMB}-confirm-cancel`,
    apply: `${JBP_PLANNING_SMB}-confirm-apply`,
  },
  notifications: {
    saveFailed: `${JBP_PLANNING_SMB}-save-failed`,
  },
} as const
